import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateField", "whenRadio", "repeatType", "repeatFields", "stopField"]

  toggleWhen() {
    const selected = this.whenRadioTargets.find(r => r.checked)?.value
    const showDate = selected === '0'

    this.dateFieldTarget.classList.toggle("d-none", !showDate)
    const input = this.dateFieldTarget.querySelector("input")
    input.required = showDate
  }

  toggleRepeat() {
    const isEvery = this.repeatTypeTarget.value === 'every'
    this.repeatFieldsTargets.forEach(el => el.classList.toggle("d-none", !isEvery))
    this.stopFieldTarget.classList.toggle("d-none", !isEvery)
  }
}
